export const BROADCAST_TYPES = {
	SATELLITE_SCHEDULED: 1
};
